import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CategoryService} from '../../../../services/vocab/category.service';
import {CategoryWithoutWordsAndSimpleReference} from '../../../../dtos/vocab/category/category-without-words-and-simple-reference';
import {NotificationService} from '../../../../services/common/notification.service';
import {WordService} from '../../../../services/vocab/word.service';
import {VocabCategoryCreationDto} from '../../../../dtos/vocab/category/vocab-category-creation-dto';
import {VocabCategoryDetailDto} from '../../../../dtos/vocab/category/vocab-category-detail-dto';
import {SharedService} from "../../../../services/common/shared.service";
import {SelectDialogComponent} from "../../../select/select-dialog/select-dialog.component";

export interface DialogData {
  id: number
}

export interface DialogData{
  id: number
}

// TODO add selected parent category to html
// TODO reload category list after creating a new one

@Component({
    selector: 'app-new-category',
    templateUrl: './new-category.component.html',
    styleUrls: ['./new-category.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewCategoryComponent implements OnInit {

  typeList = ['Wortfeld', 'DACH-Feld'];
  selectedParentCategory: CategoryWithoutWordsAndSimpleReference;
  edit: boolean;
  id: number;

  firstFormGroup: UntypedFormGroup; // name, type (WF, DACH, Category)
  secondFormGroup: UntypedFormGroup; // category

  constructor(private addWordDialogue: MatDialog, private guideWordDialogue: MatDialog, private sharedService: SharedService,
              private notificationService: NotificationService, private categoryService: CategoryService, private wordService: WordService,
              private _formBuilder: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
              private dialogRef: MatDialogRef<NewCategoryComponent>) {
    this.id = this.injectedData == null ? null : this.injectedData.id;
  }

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      nameCtrl: ['', Validators.required],
      typeCtrl: [''],
    });
    this.secondFormGroup = this._formBuilder.group({
      categoryCtrl: ['']
    });
    if (this.injectedData !== null) {
      this.edit = true;
      this.categoryService.getCategoryByID(this.injectedData.id).subscribe(c => {
        this.setForm(c);
      });
    }
    this.secondFormGroup.get('categoryCtrl')?.disable();
  }

  transformAttributeToType(c: VocabCategoryDetailDto): string {
    if (c.isDach) {
      return 'DACH-Feld';
    }
    if (c.isWordField) {
      return 'Wortfeld';
    }
    return '';
  }

  setForm(c: VocabCategoryDetailDto) {
    if (c.parent) {
      this.selectedParentCategory = new CategoryWithoutWordsAndSimpleReference(c.parent.id, c.parent.name, null, null, null, null, null);
      this.sharedService.toggleAllSelection(this.secondFormGroup.controls.categoryCtrl, [this.selectedParentCategory]);
    }
    this.firstFormGroup = this._formBuilder.group({
      nameCtrl: new UntypedFormControl(c.name, [Validators.required]),
      typeCtrl: new UntypedFormControl(this.transformAttributeToType(c))
    });
  }


  saveOrCreateCategory() {
    const category = new VocabCategoryCreationDto(
      this.id,
      this.firstFormGroup.controls.nameCtrl?.value,
      this.selectedParentCategory?.id,
      !this.selectedParentCategory,
      this.getIsWordFieldFromInput(this.firstFormGroup.controls.typeCtrl?.value),
      this.getIsDACHFieldFromInput(this.firstFormGroup.controls.typeCtrl?.value)
    );
    this.sendCategoryRequest(category);
  }

  getIsDACHFieldFromInput(s: string) {
    return s === this.typeList[1];
  }

  getIsWordFieldFromInput(s: string) {
    return s === this.typeList[0];
  }

  sendCategoryRequest(category: VocabCategoryCreationDto) {
    if (!this.edit) {
      this.categoryService.createCategory(category).subscribe(cat => {
        this.notificationService.openSnackBar('Thema \'' + cat.name + '\' erstellt');
        this.dialogRef.close(cat);
      }, error => {
        this.notificationService.openSnackBar(error);
      });
    } else {
      this.categoryService.updateCategory(category).subscribe(cat => {
          this.notificationService.openSnackBar(cat.name + ' aktualisiert.');
          this.dialogRef.close(cat);
        }, error => {
          this.notificationService.openSnackBar(error);
        }
      );
    }
  }

  openCategorySelectionDialog() {
    const dialogRef = this.guideWordDialogue.open(SelectDialogComponent, {
      data: {
        selectedObject: this.selectedParentCategory,
        displayedColumns: ['single-select', 'voc-cat-name', 'voc-cat-type', 'voc-cat-parent'],
        selectionEntity: 'vocab_category',
        dialogTitle: 'Überthema auswählen',
        selectionMode: 'single-select',
        excludedId: this.id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.length > 0) {
          this.selectedParentCategory = result[0];
          this.sharedService.toggleAllSelection(this.secondFormGroup.controls.parentCtrl, [this.selectedParentCategory]);
        }else {
          this.selectedParentCategory = null;
          this.sharedService.toggleAllSelection(this.secondFormGroup.controls.parentCtrl, []);
        }
      }
      this.secondFormGroup.get('parentCtrl')?.disable();
    });
  }
}
